(function () {
  if (window.__rrProductNavigationReady) return;
  window.__rrProductNavigationReady = true;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    const slot = document.querySelector('[data-rr-product-nav-slot]');
    const nav = slot && slot.querySelector('[data-rr-product-nav]');
    const main = document.getElementById('MainContent');
    if (!nav || !main || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const header = document.querySelector('.section-header');
    let targets = [];
    function refresh() {
      targets = Array.from(main.querySelectorAll('[data-rr-product-target]'));
      const reviews = main.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .rr-pdp-reviews');
      if (reviews) {
        if (!reviews.id) reviews.id = 'rr-product-reviews-target';
        reviews.classList.add('rr-product-review-target');
        targets.push(reviews);
      }
      const seen = new Set();
      const links = [];
      targets.forEach(target => {
        const label = target === reviews ? 'Reviews' : target.dataset.rrProductTarget;
        if (!target.id || seen.has(label)) return;
        seen.add(label);
        links.push([target.id, label]);
      });
      const signature = JSON.stringify(links);
      if (nav.dataset.links !== signature) {
        nav.replaceChildren(...links.map(([id, label]) => {
          const link = document.createElement('a');
          link.href = '#' + id;
          link.textContent = label;
          return link;
        }));
        nav.dataset.links = signature;
      }
      nav.hidden = links.length === 0;
      update();
    }
    function headerBottom() {
      if (!header) return 0;
      const style = getComputedStyle(header);
      if (style.position !== 'sticky' && style.position !== 'fixed') return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    }
    function update() {
      const top = headerBottom();
      const fixed = slot.getBoundingClientRect().top <= top;
      nav.classList.toggle('is-fixed', fixed);
      nav.style.setProperty('--rr-product-header-bottom', top + 'px');
      slot.style.minHeight = nav.hidden ? '0px' : nav.getBoundingClientRect().height + 'px';
      // Keep the header's full height reserved for targets when it reveals on scroll-up.
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--rr-product-controls-height', (headerHeight + nav.offsetHeight) + 'px');
      nav.style.visibility = fixed && main.getBoundingClientRect().bottom < top + nav.offsetHeight ? 'hidden' : '';
    }
    let frame;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; update(); });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const resize = new ResizeObserver(schedule);
    resize.observe(nav);
    if (header) resize.observe(header);
    const mutations = new MutationObserver(refresh);
    // Judge.me may mount its review widget after page initialization.
    mutations.observe(main, { childList: true, subtree: true });
    function navigate(target, smooth) {
      if (!target) return;
      const disclosure = target.matches('details') ? target : target.closest('details');
      if (disclosure) disclosure.open = true;
      update();
      const height = (header ? header.getBoundingClientRect().height : 0) + nav.offsetHeight + 16;
      const focusTarget = target.matches('details') ? target.querySelector('summary') : target;
      if (focusTarget) {
        if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('summary')) focusTarget.tabIndex = -1;
        focusTarget.focus({ preventScroll: true });
      }
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - height), behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' });
    }
    nav.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      history.replaceState(null, '', link.hash);
      navigate(target, true);
    });
    refresh();
    if (location.hash) {
      const target = document.getElementById(location.hash.slice(1));
      if (targets.includes(target)) navigate(target, false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
